import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { TokenStorageService } from "../service/token-storage.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private tokenStorage: TokenStorageService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
  // console.log('[JwtInterceptor] intercepting request to URL:', request.url);
    let token = this.tokenStorage.getToken();
    if (token) {
// console.log('[JwtInterceptor] token =', token);
      const cloneReq = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      })
     return next.handle(cloneReq);
    }      //console.log("View", request)

    return next.handle(request.clone());
  }
}
